import { OrderFilter } from 'app/models/orderFilter.model';
import { ICalculateDeliveryModel } from 'app/models/ICalculateDeliveryModel';

export class IncreaseOrderCount {
  static readonly type = '[OrderCount] Increase';
}

export class MarkViewOrders {
  static readonly type = '[Orders] MarkView';
}

export class SetOrdersList {
  static readonly type = '[Orders] Set orders list';

  constructor(public filter: OrderFilter) {
  }
}

export class UpdateOrder {
  static readonly type = '[Orders] Update order';

  constructor(public orderInQueue) {
  }
}

/** Перечитать заказ с бэка и обновить его в списке и в текущем заказе (после ручной смены статуса). */
export class ReloadOrder {
  static readonly type = '[Orders] Reload order';

  constructor(public orderId: string) {
  }
}

export class SetCurrentOrder {
  static readonly type = '[Orders] Set current';

  constructor(public orderId: string | null) {
  }
}

export class SetDeliveryHistory {
  static readonly type = '[Orders] Set delivery history';

  constructor() {
  }
}

export class SetDeliveringCalculates {
  static readonly type = '[Orders] Set Delivering Calculates';

  constructor(public calculates: ICalculateDeliveryModel[]) {
  }
}
